/**
 * Manages communications with Companion
 */
export { isAuthError } from './AuthError.js';
export { defaultStorage } from './defaultStorage.js';
export { default as getAllowedHosts } from './getAllowedHosts.js';
export { createGooglePickerController, createGooglePickerStoreAdapter, InvalidTokenError, } from './googlePicker.js';
export { default as Provider } from './Provider.js';
export { default as RequestClient, } from './RequestClient.js';
export { default as SearchProvider } from './SearchProvider.js';
import * as deprecatedTokenStorage from './tokenStorage.js';
/**
 * @deprecated
 *   Use `defaultStorage` instead.
 */
export const tokenStorage = deprecatedTokenStorage;
